<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 
 
 
 
 
 <link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="txc1" id="pz6-1"><a id="page_vi"><b>A Mayberry Grace</b></a></p><a id="page_vi">
<p class="txc" id="pz6-2" style="margin-top: 1em;">Give us, Lord, a bit o’ sun,<br/> A bit o’ work, and a bit o’ fun.<br/> Give us all in the struggle and splutter,<br/> Our daily bread and a bit o’ butter.</p>
<p class="txc" id="pz6-6"><i>Origin unknown, submitted by Margie Mode<br/> Clarksville, Indiana</i></p>
<p class="txc1" id="pz6-8"><b>A Favorite Recipe</b> </p>
<p class="txc" id="pz6-9"><i>Good for All Souls</i> </p>
<p class="txc" id="pz6-10">Take a cup of kindness,<br/> And mix it well with love.<br/> Add a lot of patience,<br/> And faith in God above.<br/> Sprinkle very generously with<br/> Joy and thanks and cheer.<br/> And you’ll have lots of angel food<br/> To feast on all the year!</p>
<p class="txc" id="pz6-18"><i>Submitted by Wanda C. Fields from her church cookbook<br/> Reidsville, North Carolina</i></p>
<div class="image" id="pz6-20">
<p class="ser"><img alt="images/img-6-1.jpg" id="z6-20" src="images/img-6-1.jpg"/></p>
<p class="txc" id="pApi"><i>Aunt Bee</i> </p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?c1763544